/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import branch from 'branch-sdk';
import { useDispatch } from 'react-redux';
import { getBranchKey } from 'Utils/UtilityFunctions';
import { actions as branchActions } from '../Slice/BranchSlice';

const BranchIo = function BranchIo() {
  const dispatch = useDispatch();
  const branchKey = getBranchKey();
  branch.init(branchKey, new Option(), (err, data) => {
    dispatch(branchActions.getBranchinit(data));
  });
  return <div />;
};

export default BranchIo;
